import { api } from "./api";

const API_BASE = import.meta.env.VITE_API_URL ?? "";

export interface BiomarkerSummary {
  name: string;
  value: string;
  reference: string;
  status: "within" | "below" | "above";
  description: string;
  commentary: string;
}

export interface ReportSummaryResult {
  good: BiomarkerSummary[];
  attention: BiomarkerSummary[];
  info_fields: Record<string, string>;
}

export interface VideoResult {
  url: string | null;
  exists: boolean;
}

export async function getReportSummary(
  testId: string,
  token: string,
): Promise<ReportSummaryResult> {
  return api<ReportSummaryResult>(
    `/api/reports/${testId}/summary?token=${encodeURIComponent(token)}`,
  );
}

export async function getMotilityVideo(
  testId: string,
  token: string,
): Promise<VideoResult> {
  const result = await api<VideoResult>(
    `/api/reports/${testId}/video?token=${encodeURIComponent(token)}`,
  );
  if (result.url && !result.url.startsWith("http")) {
    result.url = `${API_BASE}${result.url}`;
  }
  return result;
}
